import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { LocalStorageService } from '@app/core/services/localStorage/local-storage.service';
import { ModalAlertService } from '@app/shared/services/modal-alert.service';
import { Messages } from '@app/shared/enums/messages.enums';
import { Roles } from '@app/shared/models/roles.model';
import { Paths } from '@app/shared/enums/paths.enums';
import { Rol } from '@app/shared/interfaces/rol';

@Injectable()
export class RolesGuard implements CanActivate {
  modulesAndRoles: Rol[] = [
    { name: 'mapa', value: 'mapModule' },
    { name: 'ordenes', value: 'orderModule' },
    { name: 'delivery', value: 'deliveryModule' },
    { name: 'sucursales', value: 'branchModule' },
    { name: 'asignaciones', value: 'assingModule' },
    { name: 'usuarios', value: 'userModule' },
    { name: 'ofertas', value: 'offerModule' },
  ];

  constructor(
    private router: Router,
    private modalAlertService: ModalAlertService,
    private localStorageService: LocalStorageService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const roles = this.localStorageService.getkeyName('roles') as Roles;

    if (state.url === Paths.home) {
      if (this.hasPermision(Paths.maps)) {
        this.router.navigate([Paths.maps]);
      }
      return true;
    }

    if (!roles) {
      this.modalAlertService.showAlert({
        width: '520px',
        data: { error: Messages.notAutorized }
      });
      this.router.navigate([Paths.login], { queryParams: { returnUrl: state.url } });
      return false;
    }

    if (roles && !this.hasPermision(state)) {
      this.modalAlertService.showAlert({
        width: '469px',
        data: { error: Messages.notAutorizedModule }
      });
      return false;
    }

    return true;
  }

  getModule(state: any): Rol {
    let url = state.url ? state.url : state;
    url = url.replace('/', '');

    return this.modulesAndRoles.find((rol) => {
      return url.includes(rol.name);
    });
  }

  hasPermision(state: any): boolean {
    const roles = this.localStorageService.getkeyName('roles') as Roles;
    const rol = this.getModule(state);
    return roles === null ? false : roles[rol.value] === true;
  }
}
